// extracted by mini-css-extract-plugin
module.exports = {"common":"index_common__3yJY2","child":"index_child__3Gdf1","header":"index_header__2oXsg","body":"index_body__1eVhN"};